export default __webpack_public_path__ + "static/screeny-85-gpz-s-3-c59f5fbeb99f86ed2cb715cf9be3f02f.jpg";